import { Divider, styled } from '@mui/material'
import { ComponentProps } from 'react'

type VerticalDividerProps = {
  sx?: any
}

function VerticalDivider({ sx }: VerticalDividerProps) {
  type DividerProps = ComponentProps<typeof Divider> & { component: string }

  const StyledDivider = styled(({ ...props }: DividerProps) => (
    <Divider {...props} />
  ))({
    // Structural only: the divider token, not a white bar.
    backgroundColor: 'var(--dewi_colors_gray_8)',
    backgroundImage: 'none',
    height: '2rem',
    ...sx,
  })
  return <StyledDivider orientation="vertical" component="div" />
}

export default VerticalDivider
